// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userMessages .enrollmentRequestContainer {
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 30px;
}

.userMessages .enrollmentRequestContainer .btn {
  margin-right: 15px;
}

.userMessages .enrollmentRequestContainer .meta > .title {
  margin-bottom: 3px;
}

.userMessages .messageBox {
  background-color: #e5e5e5;
  border: 1px solid #fff;
  height: 210px;
  padding: 30px 15px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/messages/requests.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".userMessages .enrollmentRequestContainer {\n  border-bottom: 1px solid #e5e5e5;\n  margin-bottom: 30px;\n}\n\n.userMessages .enrollmentRequestContainer .btn {\n  margin-right: 15px;\n}\n\n.userMessages .enrollmentRequestContainer .meta > .title {\n  margin-bottom: 3px;\n}\n\n.userMessages .messageBox {\n  background-color: #e5e5e5;\n  border: 1px solid #fff;\n  height: 210px;\n  padding: 30px 15px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
